import axios from 'axios';
import { AxiosInstance } from '../common/Loader/axios.config';

// const AxiosInstance = axios.create({
//     baseURL: 'https://dev.staticcomputersinc.com/kanemaonline',
// });

class ContentService {

    static async getContent(limit = 100, item = ""): Promise<any[]> {
        let skip = 0;
        let hasMore = true;
        const allProducts: any[] = [];

        // Get provider data from localStorage
        const providerData = JSON.parse(localStorage.getItem("provider") || "{}") as { id?: string; userType?: string };

        while (hasMore) {
            try {
                console.log('Fetching Projects');
                const response = await AxiosInstance.get('/products', {
                    params: {
                        skip,
                        limit,
                        item,
                    },
                });
                const products = response.data.message;
                console.log('Fetched Products:', products);

                if (!products || products.length === 0) {
                    hasMore = false;
                    break;
                }

                // Filter projects based on userType
                const filteredProducts = providerData.userType === "admin"
                    ? products
                    : products.filter((product: any) => product.provider?.[0]._id === providerData.id)

                console.log('Filtered Products:', filteredProducts);

                allProducts.push(...filteredProducts);
                hasMore = filteredProducts.length === limit;
                skip += limit;
            } catch (error) {
                console.error('Error fetching products:', error);
                throw error;
            }
        }

        console.log('All Products:', allProducts);

        return allProducts;
    }

    static async getVideos(limit = 100, item = ""): Promise<any[]> {
        let skip = 0;
        let hasMore = true;
        const allVideos: any[] = [];

        // Get provider data from localStorage
        const providerData = JSON.parse(localStorage.getItem("provider") || "{}") as { id?: string; userType?: string };

        while (hasMore) {
            try {
                console.log('Fetching Videos');
                const response = await AxiosInstance.get('/content-videos', {
                    params: {
                        skip,
                        limit,
                        item,
                    },
                });
                const videos = response.data.message;
                console.log('Fetched Videos:', videos);

                if (!videos || videos.length === 0) {
                    hasMore = false;
                    break;
                }

                // Filter projects based on userType
                const filteredVideos = providerData.userType === "admin"
                    ? videos
                    : videos.filter((video: any) => video.providerObj?.[0]._id === providerData.id)

                console.log('Filtered Videos:', filteredVideos);

                allVideos.push(...filteredVideos);
                hasMore = filteredVideos.length === limit;
                skip += limit;
            } catch (error) {
                console.error('Error fetching videos:', error);
                throw error;
            }
        }

        console.log('All Videos:', allVideos);

        return allVideos;
    }
}

export default ContentService;
